import React from 'react'

type IconBookOpenProps = {
    fill?: string
}

export const IconBookOpen = ({ fill }: IconBookOpenProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            fill="none"
        >
            <path
                fill={fill ?? '#043DE2'}
                d="M16.5 4c1.92 0 3.703.523 5.054 1.42a1 1 0 0 1 .446.833v13a1 1 0 0 1-1.554.833C19.461 19.43 18.073 19 16.5 19s-2.96.431-3.946 1.086a1 1 0 0 1-1.108 0C10.461 19.43 9.073 19 7.5 19s-2.96.431-3.946 1.086A1 1 0 0 1 2 19.253v-13a1 1 0 0 1 .446-.833C3.796 4.523 5.58 4 7.5 4c1.668 0 3.233.395 4.5 1.087C13.267 4.395 14.832 4 16.5 4Zm-9 2c-1.348 0-2.56.317-3.5.82v10.807A9.82 9.82 0 0 1 7.5 17a9.82 9.82 0 0 1 3.5.627V6.82C10.06 6.317 8.848 6 7.5 6Zm9 0c-1.348 0-2.56.317-3.5.82v10.807A9.821 9.821 0 0 1 16.5 17c1.252 0 2.446.223 3.5.627V6.82c-.94-.503-2.152-.82-3.5-.82Z"
            />
        </svg>
    )
}

IconBookOpen.displayName = 'IconBookOpen'
